/**
 * CategorySelection.js
 * Written by: Alex Kasemir
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';

import categorySelectors from 'store/category/selectors';
import categoryActions from 'store/category/actions';

import event from 'utils/event';
import { SUBCATEGORY_SELECTOR_BREAKPOINT } from 'root/theme';

import {
  CategorySelectionContainer,
  CategoryButtonGroup,
  CategorySelectDropdown,
} from './CategorySelection.styles';


/**
 * View you submitted questions
 *
 */
export class CategorySelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: null,
    };
  }

  componentDidMount() {
    const { getCategories } = this.props;

    getCategories();
    if (__CLIENT__) {
      this.updateWidth();
      window.addEventListener(`resize`, this.debouncedUpdateWidth);
    }
  }

  componentDidUpdate() {
    const { selectCategory, selectedCategoryId, categories } = this.props;

    if (!selectedCategoryId && categories[0]) {
      selectCategory({ id: categories[0].id });
    }
  }

  componentWillUnmount() {
    if (__CLIENT__) {
      window.removeEventListener(`resize`, this.debouncedUpdateWidth);
    }
  }

  onSelect = (e) => {
    const { selectCategory } = this.props;

    event(`select-category`, [`click`, `select-category`, `${e.target.value}`]);

    selectCategory({ id: parseInt(e.target.value, 10) });
  }

  updateWidth = () => {
    this.setState({ width: window.innerWidth });
  }

  debouncedUpdateWidth = debounce(this.updateWidth, 200);

  render() {
    const { categories, selectedCategoryId, isDesktop } = this.props;
    const { width } = this.state;
    if (categories.length === 0) {
      return null;
    }

    const categoryButtons = categories.map((cat) => {
      return {
        label: cat.name,
        value: cat.id,
        selected: selectedCategoryId && cat.id === parseInt(selectedCategoryId, 10),
      };
    });

    // TODO: use react responsive for this component and make a pantheon model for
    // the width -> device mapping
    const firstClientRender = __CLIENT__ && width === null;

    return (
      <CategorySelectionContainer>
        {
          (
            (firstClientRender && isDesktop)
            || width > SUBCATEGORY_SELECTOR_BREAKPOINT
            || (__SERVER__ && isDesktop)
          )
            ? <CategoryButtonGroup
              buttons={ categoryButtons }
              onSelect={ this.onSelect }
              vertical
              fixed
            />
            : <CategorySelectDropdown
              items={ categoryButtons }
              onChange={ this.onSelect }
            />
        }
      </CategorySelectionContainer>
    );
  }
}

CategorySelection.propTypes = {
  categories: PropTypes.array,
  selectedCategoryId: PropTypes.number,
  getCategories: PropTypes.func.isRequired,
  selectCategory: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool,
};

export default connect((state) => {
  return {
    session: state.user.session,
    selectedCategoryId: state.category.selected,
    categories: categorySelectors.all(state),
    isDesktop: state.extra.device.isDesktop,
  };
}, {
  getCategories: categoryActions.getCategories,
  selectCategory: categoryActions.selectCategory,
})(CategorySelection);
